import React from 'react';
import { faInfoCircle } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

export const TooltipIcon: React.FC<React.PropsWithChildren<unknown>> = () => {
	return <FontAwesomeIcon icon={faInfoCircle} />;
};

export default TooltipIcon;
